import { useFilter } from "reka-ui";
import {
  computed,
  ref,
  toValue,
  type ComputedRef,
  type MaybeRefOrGetter,
} from "vue";
import type { Tag } from "./types";

export const useTagSuggestionFilter = (
  availableTagsRef: MaybeRefOrGetter<Array<Tag>>,
  selectedTagsRef: MaybeRefOrGetter<Array<Tag>>,
  createTag: (query: string) => Tag,
) => {
  const query = ref("");
  const normalizedQuery = computed(() => query.value.trim());

  const filteredTags: ComputedRef<Array<Tag>> = computed(() => {
    const availableTags = toValue(availableTagsRef);
    const selectedTags = toValue(selectedTagsRef);

    const { contains } = useFilter({ sensitivity: "base" });
    return availableTags.filter(
      (tag) =>
        contains(tag.name, normalizedQuery.value) &&
        !selectedTags.some((selectedTag) => selectedTag.name === tag.name),
    );
  });

  const newTag = computed(() => {
    if (!normalizedQuery.value) return;

    const selectedTags = toValue(selectedTagsRef);
    const exactMatch = [...selectedTags, ...filteredTags.value].some(
      (tag) => tag.name.toLowerCase() === normalizedQuery.value.toLowerCase(),
    );
    if (exactMatch) return;
    return createTag(normalizedQuery.value);
  });

  return { query, filteredTags, newTag };
};
